export const buildCaseListAppoitments = (
  cases,
  components,
  appData,
  handleButtonClick
) => {
  const { CaseListItemAppoitments: caseListItemAppoitments } = components;

  return caseListItemAppoitments({
    cases,
    components,
    appData,
    onView: data =>
      handleButtonClick("selectedData", { selectedData: { ...data } })
  });
};
